import { jsx as _jsx } from "react/jsx-runtime";
import HyperDX from '@hyperdx/browser';
import { isNil } from 'lodash';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { compose } from 'redux';
import { Spinner, APPLICANTS_URL, PRODUCT_TYPE, useIovation, approveTerms, reportError, } from 'shared';
import { useGetConsumerApplicationsV1PrequalificationsNewQuery, usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation, usePostConsumerApplicationsV1CreditApplicationsApplicationIdPrequalifyMutation, } from 'consumer-applications-v1-api';
import { determinePrequalificationResponse, toastError, flashSubmitFailure, } from 'utils';
import { setPrequalification, setApplicationEnvironment as setApplicationEnvironmentCreditApplication, } from '../../credit_application/actions';
import * as actions from '../actions';
import { setApplicationEnvironment as setApplicationEnvironmentApplicant } from '../actions';
import { selectors } from '../reducer';
import ApplicantShow from './ApplicantShow';
function NewAccessLoan({ applicationEnvironment, clearApplicant, clearApplicationEnvironment, creditApplication, practice, }) {
    const { search } = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [getBlackboxData] = useIovation();
    const { locationId } = practice || {};
    const { data: newCreditApplication, isFetching: isFetchingCreditApplication, } = useGetConsumerApplicationsV1PrequalificationsNewQuery({ locationId });
    const [patchApplicant] = usePatchConsumerApplicationsV1CreditApplicationsApplicationIdMutation();
    const [prequalifyCreditApplication] = usePostConsumerApplicationsV1CreditApplicationsApplicationIdPrequalifyMutation();
    const { applicationId, locationServiceProviderPriorities } = creditApplication;
    const handleSubmit = (prequalificationFormValues) => {
        const { alphaeonTerms, lenderTerms } = applicationEnvironment;
        HyperDX.setGlobalAttributes({
            locationId: practice.locationId.toString() || '',
            storeNumber: practice.adsStoreNumber.toString() || '',
            creditApplicationId: creditApplication.applicationId?.toString() || '',
            lastName: prequalificationFormValues.lastName,
            firstName: prequalificationFormValues.firstName,
            email: prequalificationFormValues.email,
            phone: prequalificationFormValues.primaryPhone,
        });
        return patchApplicant({
            applicationId: applicationId,
            patchConsumerApplicationsV1CreditApplicationsApplicationId: prequalificationFormValues,
        }).then(() => {
            const { consumer } = locationServiceProviderPriorities;
            const accessLoanPriority = consumer.find(({ productType }) => productType === PRODUCT_TYPE.ACCESS_LOAN);
            if (isNil(accessLoanPriority)) {
                const errMsg = `No consumer-accessible access loan plans configured for location [${practice.name}]`;
                reportError('flashError', {
                    componentName: 'NewAccessLoan',
                    errType: 'db',
                    errURL: window.location.pathname,
                    errMsg: errMsg,
                });
                return toastError(errMsg);
            }
            const prequalificationRequest = {
                priority: accessLoanPriority.priority,
                iovationBlackBox: getBlackboxData().blackbox,
                prerequisiteTermsAccepted: approveTerms(alphaeonTerms, lenderTerms),
            };
            return prequalifyCreditApplication({
                applicationId,
                postConsumerApplicationsV1CreditApplicationsApplicationIdPrequalify: prequalificationRequest,
            }).then((response) => {
                if ('data' in response) {
                    setPrequalification(response.data);
                    return { ...response };
                }
            });
        });
    };
    const handleSubmitSuccess = (response) => {
        const nextStep = determinePrequalificationResponse(response, 'no-modal');
        history.push(nextStep);
        return;
    };
    useEffect(() => {
        if (newCreditApplication) {
            dispatch(setApplicationEnvironmentApplicant(newCreditApplication));
            dispatch(setApplicationEnvironmentCreditApplication(newCreditApplication));
        }
    }, [newCreditApplication]);
    useEffect(() => {
        return () => {
            clearApplicant();
            clearApplicationEnvironment();
        };
    }, []);
    if ((isNil(creditApplication) && !isFetchingCreditApplication) || !practice) {
        return (_jsx(Redirect, { to: {
                pathname: APPLICANTS_URL,
                search: search,
            } }));
    }
    if (!applicationEnvironment)
        return _jsx(Spinner, { centerPage: true });
    return (_jsx(ApplicantShow, { practice: practice, handleSubmit: handleSubmit, handleSubmitSuccess: handleSubmitSuccess, handleSubmitFailure: flashSubmitFailure, applicationEnvironment: applicationEnvironment }));
}
function mapStateToProps(state) {
    return {
        creditApplication: selectors.creditApplication(state),
        applicationEnvironment: selectors.applicationEnvironment(state),
        personalInfo: selectors.personalInfo(state),
        practice: selectors.practice(state),
    };
}
const mapDispatchToProps = {
    clearApplicant: actions.clearApplicant,
    clearApplicationEnvironment: actions.clearApplicationEnvironment,
    setPrequalification: setPrequalification,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(NewAccessLoan);
